module.exports = __webpack_public_path__ + "static/media/icon-send.6df667a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-send.svg
// module id = 1251
// module chunks = 19